// src/modules/auth/logout.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

function Logout() {
  const navigate = useNavigate();
  const { logout } = useAuth(); // useAuth フックから logout メソッドを取得

  useEffect(() => {
    logout(); // AuthProvider の logout メソッドを呼び出す
    navigate('/lp'); // lp.jsx ページにリダイレクト
  }, [navigate, logout]);

  // ログアウト中の表示（必要に応じて変更）
  return <div>ログアウトしています...</div>;
}

export default Logout;